module.exports = __webpack_public_path__ + "static/img/watress.256111c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/watress.png
// module id = VorU
// module chunks = 32